// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__sDbfg","active":"Pagination_active__3IIlC","pageNumbers":"Pagination_pageNumbers__aDcRv"};